import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink px-4 pb-32 pt-10 text-center sm:px-6" data-id="element-149" data-mp="32wmqrybuniwl">
      <p className="text-sm font-semibold text-white" data-id="element-150" data-mp="3ggaovpzpm32t">© 2026 Automotive Parasitic Drain Diagnostic Blueprint™.</p>
      <p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-mist" data-id="element-151" data-mp="32pfeuadh5fxn">
        Professional educational resource. Intended for qualified automotive professionals. Always follow vehicle
        manufacturer service procedures, equipment instructions, and applicable electrical safety requirements. This
        resource does not guarantee a particular diagnostic outcome or repair time.
      </p>
    </footer>;
}